export const EMPTY_MOD = 'Mod_Vacant';
export const API_ROOT = `${process.env.REACT_APP_API}/${process.env.REACT_APP_API_VERSION}`;
export const BASE_ROOT = process.env.REACT_APP_API;
export const CDN_ROOT = process.env.REACT_APP_CDN;
export const MISSING_ICON = `${process.env.REACT_APP_CDN}/interface/Item_None.webp`;
